// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// Lodash
import { each } from 'lodash-es';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
import { PatientImageChangeRequest } from '../_models/patient-image-change-request.model';
// State
import { PatientImageChangeRequestState } from '../_reducers/patient-image-change-request.reducers';

export const selectPatientImageChangeRequestState =
  createFeatureSelector<PatientImageChangeRequestState>('requests');

export const selectPatientImageChangeRequestsPageLoading = createSelector(
  selectPatientImageChangeRequestState,
  (patientImageChangeRequestState) => patientImageChangeRequestState.listLoading,
);

export const selectPatientImageChangeRequestsActionLoading = createSelector(
  selectPatientImageChangeRequestState,
  (patientImageChangeRequestState) => patientImageChangeRequestState.actionsloading,
);

export const selectPatientImageChangeRequestErrorState = createSelector(
  selectPatientImageChangeRequestState,
  (patientImageChangeRequestState) => patientImageChangeRequestState.error,
);

export const selectPatientImageChangeRequestLatestSuccessfullAction = createSelector(
  selectPatientImageChangeRequestState,
  (patientImageChangeRequestState) => patientImageChangeRequestState.latestSuccessfullAction,
);

export const selectPatientImageChangeRequestShowInitWaitingMessage = createSelector(
  selectPatientImageChangeRequestState,
  (patientImageChangeRequestState) => patientImageChangeRequestState.showInitWaitingMessage,
);

export const selectPatientImageChangeRequestsInStore = createSelector(
  selectPatientImageChangeRequestState,
  (patientImageChangeRequestState) => {
    const items: PatientImageChangeRequest[] = [];
    each(patientImageChangeRequestState.entities, (i) => items.push(i));
    return new QueryResultsModel(items, patientImageChangeRequestState.totalCount);
  },
);
